export enum EApplicationType {
  PAYMENT = 'PAYMENT',
  PURCHASE = 'PURCHASE',
  SELL = 'SELL',
}

export const stringToEApplicationType = (str: string) =>
  EApplicationType[str.toUpperCase() as keyof typeof EApplicationType]
